import React from "react";
import Preloader from "../../helper/Preloader";
 import Breadcrumb from "../../components/Breadcrumb";
import FooterOne from "../../components/FooterOne";
 import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";
 import { useDispatch } from "react-redux";
import { setSelectedProductStore } from "../../common/slices/productSlice";
 import HomeSectionDetailsSampleAmazon from "../../componentsAmazon/HomeSectionDetailsSampleAmazon";

const HomePageDetailsSampleAmazon = () => {

  const dispatch = useDispatch(); 
  
  const handleBackToStore = () => {
    dispatch(setSelectedProductStore(null)); // Clear selected product
  };
 
    
  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOneCustomer category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Product"} />

      {/* Conditionally Render Components */}

         <HomeSectionDetailsSampleAmazon  onBack={handleBackToStore} />
      
      {/* FooterOne */}
      <FooterOne />


    </>
  );
};

export default HomePageDetailsSampleAmazon;
